import { styled } from "../../../styles";

export const ModalBodyText = styled("p", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$charcoal",
  margin: 0,

  "& strong": {
    fontWeight: 700,
  },
});

/** Logo shown against a neutral tile — most tenant logos are light on white. */
/**
 * Preview beside its picker, not stacked above it (EN-5146 UI feedback).
 * The card runs the full width of the page, so a full-width drop zone left
 * "Choose file" marooned half a screen from the file name it acts on, with
 * the preview, the field, two separate hints and the buttons each starting
 * at a different place down the card.
 */
export const LogoLayout = styled("div", {
  display: "grid",
  gridTemplateColumns: "220px minmax(320px, 640px)",
  gap: "24px",
  alignItems: "start",

  "@media (max-width: 900px)": {
    gridTemplateColumns: "1fr",
  },
});

/**
 * Fixed frame for the logo, so the "has one" and "doesn't" states are the
 * same size and a logo that fails to load — a broken URL, a bucket the
 * environment can't reach — cannot stretch the card with its alt text.
 */
export const LogoPreviewFrame = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "104px",
  padding: "12px",
  borderRadius: "6px",
  border: "1px solid $gray-30",
  backgroundColor: "$gray-20",
  overflow: "hidden",
});

export const LogoPreview = styled("img", {
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
});

export const LogoPreviewEmpty = styled("p", {
  margin: 0,
  textAlign: "center",
  color: "$gray-60",
  fontFamily: "$openSans",
  fontSize: "13px",
  lineHeight: 1.4,
});

/**
 * Region pill for a tenant. A region isn't a status, so this is its own badge
 * rather than a `StatusBadge` variant — that one's grey dot said nothing and
 * implied "inactive".
 */
export const RegionBadge = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "3px 10px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.02em",
  fontFamily: "$openSans",
  border: "1px solid transparent",

  variants: {
    region: {
      EU: {
        backgroundColor: "$secondary-lightest",
        borderColor: "$secondary-light",
        color: "$secondary-darker",
      },
      US: {
        backgroundColor: "$primary-20",
        borderColor: "$primary-30",
        color: "$primary-70",
      },
      unknown: {
        backgroundColor: "$gray-20",
        borderColor: "$gray-30",
        color: "$gray-80",
      },
    },
  },

  defaultVariants: {
    region: "unknown",
  },
});

/**
 * The flag itself. Regional-indicator emoji don't render on every platform
 * (Windows Chrome shows the letter pair), which is fine: the region code sits
 * beside it and carries the meaning on its own.
 */
export const RegionFlag = styled("span", {
  fontSize: "14px",
  lineHeight: 1,
});
